/* Orvia · original code by Stellar Virtex */
(() => {
  class CookieBanner extends HTMLElement {
    connectedCallback() {
      if (window.Shopify && window.Shopify.designMode && this.dataset.preview === 'true') { this.hidden = false; return; }
      if (!window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        if (err) return;
        const api = window.Shopify.customerPrivacy;
        if (api && api.shouldShowBanner && api.shouldShowBanner()) this.hidden = false;
      });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-consent]');
        if (!btn) return;
        const ok = btn.dataset.consent === 'accept';
        const api = window.Shopify && window.Shopify.customerPrivacy;
        if (api) api.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, () => {});
        this.hidden = true;
      });
    }
  }
  customElements.define('cookie-banner', CookieBanner);
})();
